/**
 * 控制全局弹窗
 */

export const state = () => ({
    _storeDefaultProps: {}, // 缓存props默认值

    reservation: {
        // 产品预约
        visible: false,
        props: {},
    },
});

/**
 * 更新props，调用时会和默认props值运算
 * @param {Object} state state
 * @param {String} name 命名空间
 * @param {Object} props 参数对象
 */
function _updateStateProps(state, name, props) {
    var oldProps = state[name].props,
        storedDefaultProps = state._storeDefaultProps[name];

    if (!storedDefaultProps) {
        // 进行缓存
        state._storeDefaultProps[name] = oldProps;
    } else {
        oldProps = storedDefaultProps;
    }

    return {
        ...oldProps,
        ...props,
    };
}

export const mutations = {
    // 更新显示状态及参数
    updateDialogVisible(state, {name, visible, ...props}) {
        state[name].visible = visible;

        if (props && Object.keys(props).length) {
            state[name].props = _updateStateProps(state, name, props);
        }
    },
    // 仅更新参数
    updateProps(state, {name, ...props}) {
        state[name].props = _updateStateProps(state, name, props);
    },
    clearCallbackByName(state, {name, fname}) {
        state[name]['props'][fname] = null;
    },
};

export const getters = {
    getGlobalDialogVisible: (state) => (name) => {
        return state[name].visible;
    },
    getGlobalDialogProps: (state) => (name) => {
        return state[name].props;
    },
};

export const actions = {
    /**
     * 开启弹窗
     * @param {Object} param0 stroe
     * @param {Object} param1 配置
     */
    openGlobalDialog({commit}, {name, ...props}) {
        commit('updateDialogVisible', {
            name,
            visible: true,
            ...props,
        });
    },
    /**
     * 关闭弹窗
     * @param {Object} param0 stroe
     * @param {Object} param1 配置
     */
    closeGlobalDialog({commit}, {name}){
        commit('updateDialogLoginVisible', {
            name,
            visible: false,
        });
    },

    callbackGlobalDialog({state, commit}, name) {
        var arr = name.split('/'),
            nameSpace = arr[0],
            funName = arr[1];

        var callback = state[nameSpace]['props'][funName];

        if (callback && typeof callback === 'function') {
            callback();
        }

        commit('clearCallbackByName', {
            name: nameSpace,
            fname: funName,
        });
    },
};